
const setBaseUrl = (path?: string) => {

  if (!path) {
    throw new Error('PATH NO DEFINIDO EN ENV');
  }

  return `${process.env.NEXT_PUBLIC_HOST as string}/${process.env.NEXT_PUBLIC_PROXY as string}/${path}`;
};

const config = Object.freeze({
  GENERAL: {
    ENVIRONMENT: process.env.NODE_ENV as string,
    BASE_URL: process.env.NEXT_PUBLIC_HOST as string,

    BASIC_USER: process.env.BASIC_USER as string,
    BASIC_PASSWORD: process.env.BASIC_PASSWORD as string,
    BASIC_PASSWORD_ENCODE: process.env.BASIC_PASSWORD_ENCODE as string,

    INTEGRATION_USER: process.env.INTEGRATION_USER as string,
    INTEGRATION_PASSWORD: process.env.INTEGRATION_PASSWORD as string,

    PROXY: `${process.env.NEXT_PUBLIC_HOST as string}/${process.env.NEXT_PUBLIC_PROXY as string}`,
    PROXY_WHITELIST: JSON.parse(process.env.PROXY_WHITE_LIST || '[]')
  },
  DB: {
    HOST: process.env.DATABASE_HOST as string,
    USER: process.env.DATABASE_USER as string,
    PASSWORD: process.env.DATABASE_PASSWORD as string
  },
  FRONTEND: {
    PUBLIC_URL: process.env.NEXT_PUBLIC_HOST as string,
    PORT: process.env.FRONTEND_PORT as string
  },
  API: {
    PRIVATE_URL: process.env.API_PRIVATE_URL as string,
    PUBLIC_URL: setBaseUrl('services'),
    PORT: process.env.API_PORT as string,
    DB_NAME: process.env.API_DB_NAME as string

  },

  AUTH: {
    PRIVATE_URL: process.env.AUTH_PRIVATE_URL as string,
    PUBLIC_URL: setBaseUrl('auth'),
    PORT: process.env.AUTH_PORT as string,
    DB_NAME: process.env.AUTH_DB_NAME as string,
    JWT_SECRET_KEY: process.env.JWT_SECRET_KEY as string,
    'RESET-URL': `${process.env.NEXT_PUBLIC_HOST as string}/${process.env.RESET_PATH as string}`
  },
  FILE_MANAGER: {
    PRIVATE_URL: process.env.FILE_MANAGER_PRIVATE_URL as string,
    PUBLIC_URL: `${process.env.NEXT_PUBLIC_HOST as string}/file-manager`,
    PORT: process.env.FILE_MANAGER_PORT as string
  },
  MAILER: {
    PRIVATE_URL: process.env.MAILER_PRIVATE_URL as string,
    PUBLIC_URL: setBaseUrl('mailer'),
    PORT: process.env.MAILER_PORT as string,
    TRANSPORTER: {
      HOST: process.env.MAILER_TRANSPORTER_HOST as string,
      PORT: process.env.MAILER_TRANSPORTER_PORT as string,
      USER: process.env.MAILER_TRANSPORTER_USER as string,
      PASSWORD: process.env.MAILER_TRANSPORTER_PASS as string,
      SECURE: process.env.MAILER_TRANSPORTER_SECURE as string
    }
  },
  PAYWAY: {
    PRIVATE_URL: process.env.PAYWAY_PRIVATE_URL as string,
    PUBLIC_URL: setBaseUrl('payway'),
    PORT: process.env.PAYWAY_PORT as string
  },
  AUTORIZACION: {
    PRIVATE_URL: process.env.AUTORIZACION_PRIVATE_URL as string,
    PUBLIC_URL: setBaseUrl('autorizacion'),
    PORT: process.env.AUTORIZACION_PORT as string
  },
  REDIS: {
    HOST: process.env.REDIS_HOST as string,
    PORT: process.env.REDIS_PORT as string,
    PASSWORD: process.env.REDIS_PASSWORD as string
  },
  MERCADO_PAGO: {
    API_KEY: process.env.MP_API_KEY as string,
    SECRET_KEY: process.env.MP_SECRET_KEY as string,
    PUBLIC_KEY: process.env.NEXT_PUBLIC_MP_PUBLIC_KEY as string
  },
  ALLARIA: {
    ENABLED: process.env.NEXT_PUBLIC_ALLARIA_ENABLED === 'true',
  }
});

export default config;